import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { Employee } from "../../core/model/employee/employee";
import { UserProfile } from "../../core/model/user-profile";
import { UserProfileSelectedDTO } from "../../core/model/user-profile-selected-dto";
import { UserProfileService } from "../../core/service/user-profile.service";
import { EmployeeService } from "../../core/service/employee.service";
import { AssocierProfileAEmployee } from "../../core/model/associer-profile-a-employee";
import { ImportUserComponent } from "../import-user/import-user.component";

@Component({
  selector: "app-profile-by-user",
  templateUrl: "./profile-by-user.component.html",
  styleUrls: ["./profile-by-user.component.scss"],
})
export class ProfileByUserComponent implements OnInit {
  employeeId: string;
  employee: Employee;

  profiles: UserProfileSelectedDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _userProfileService: UserProfileService,
    private _employeeService: EmployeeService
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.employeeId = params["userId"];
      this.getEmployeeById(this.employeeId);
      this.findSelectedProfiles(this.employeeId);
    });
  }

  getEmployeeById(employeeId) {
    this._employeeService.getEmployeeById(employeeId).subscribe(
      (data) => {
        this.employee = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findSelectedProfiles(employeeId) {
    this._userProfileService.findSelectedProfiles(employeeId).subscribe(
      (data) => {
        this.profiles = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeAfterChecked(values: any, profileId) {
    var input = new AssocierProfileAEmployee();
    input.profileId = profileId;
    input.employeeId = this.employeeId;
    input.selected = values.currentTarget.checked;
    this.associer(input);
  }

  associer(associerProfileAEmployee: AssocierProfileAEmployee) {
    this._userProfileService.associer(associerProfileAEmployee).subscribe(
      (data) => {
        this.findSelectedProfiles(this.employeeId);
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }
}
